import React from 'react';

export default class EmojiBabyBottle extends React.PureComponent {
  render() {
    return (<span className='emoji' role='img' aria-label='Baby Bottle'>🍼</span>);
  }
}
